import Backbone from 'backbone';
import {
  formatInteger,
} from '@bingads-webui-campaign/recommendation-core';
import template from './sharedBudgetVNext.pug';

export class SharedBudgetContextualAttributeViewVNext extends Backbone.View {
  initialize({
    deps,
    i18n,
    isMCC,
    targetId,
  }) {
    this.deps = deps;
    this.i18n = i18n;
    this.isMCC = isMCC;
    this.sharedBudgetId = targetId;
    this.campaignsCount = '';
  }


  render({
    showDeliveryStatusPopup,
    recommendationAccountId,
  }) {
    const {
      deps,
      sharedBudgetId,
      i18n,
    } = this;
    const options = this.isMCC ?
      {
        entitySet:
          deps
            .edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(recommendationAccountId))
            .Budgets,
      } : {};

    deps.jsdata.Budget.findAll({
      limit: 1,
      select: ['AssociationCount'],
      where: { Id: { $eq: sharedBudgetId } },
    }, options).then((response) => {
      if (response.length && response.length > 0) {
        const campaignsCount = response[0].AssociationCount;

        this.campaignsCount = i18n.getString(
          'Shared_Budget_Recommendation_CampaignCount',
          { campaignsCount: formatInteger(campaignsCount, i18n) }
        );

        this.$el.html(template({
          campaignsCount: this.campaignsCount,
        }));

        showDeliveryStatusPopup(this.el.outerHTML);
      }
    });
    return this;
  }
}
